module.exports = __webpack_public_path__ + "static/media/unlock-green.218a07da.svg";